import { Component, inject, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';

import { FundDataService } from '../../../../components/core/services/fund-data.service';
import { PORTFO, RESULT_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { PortfoService } from '../../services/portfo.service';
import { PurchasePowerComponent } from '../../components/purchase-power/purchase-power.component';
import { WalletBalanceInfoComponent } from '../../components/wallet-balance-info/wallet-balance-info.component';
import { CashOutConfirmPaymentComponent } from '../../components/cashout-confirm-payment/cash-out-confirm-payment.component';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { WalletAmountFormComponent } from '../../../wallet/components/wallet-amount-form/wallet-amount-form.component';
import { DecimalPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-cash-out',
  standalone: true,
  imports: [
    PipesModule,
    NgxButtonComponent,
    ReactiveFormsModule,
    UiFormFieldBuilderModule,
    NgxAppBarComponent,
    WalletAmountFormComponent,
    DecimalPipe,
    SpinnerComponent,
  ],
  templateUrl: './cash-out.component.html',
  styleUrl: './cash-out.component.scss',
})
export class CashOutComponent implements OnInit {
  isLoading = signal<boolean>(false);
  isValid = signal<boolean>(false);
  showError = signal<boolean>(false);
  amount = signal<string | undefined>(undefined);
  balance = signal<{ balance: number; withdrawalBalance: number }>({ balance: 0, withdrawalBalance: 0 });

  private portfoService = inject(PortfoService);
  private fundDataService = inject(FundDataService);
  private bottomSheet = inject(NgxBottomSheetService);
  private navigationService = inject(WealthNavigationService);
  minAmount = signal<number | undefined>(100000);

  ngOnInit(): void {
    this.isLoading.set(true);
    this.portfoService.getWalletInfo().subscribe((res) => {
      this.isLoading.set(false);
      if (res?.success) {
        this.balance.set({ balance: res.result?.balance, withdrawalBalance: res.result?.withdrawalBalance });
      }
    });
  }

  showCashoutConfirmPayment(all?: 'all') {
    this.portfoService.getEtfWalletInfo().subscribe((res) => {
      this.isLoading.set(false);
      if (res?.success) {
        this.bottomSheet.openBottomSheet(CashOutConfirmPaymentComponent, {
          data: {
            bankName: res.result?.bankName,
            shabaNumber: res.result?.shabaNumber,
            amount: all ? this.balance().balance : this.amount(),
          },
        });

        const bottomSheetService = this.bottomSheet.onClose.subscribe(() => {
          bottomSheetService.unsubscribe();
          const result = this.bottomSheet.outputData();
          if (result) {
            this.cashout(all);
          }
        });
      }
    });
  }

  onBackHandler() {
    this.navigationService.navigate([PORTFO]);
  }

  amountChanged(data: { value: string; valid: boolean }) {
    this.isValid.set(data.valid);
    this.amount.set(data.value);
  }

  showPurchasePowerInfo() {
    this.bottomSheet.openBottomSheet(PurchasePowerComponent, {
      data: {
        image: 'wealth-assets/svg/purchase-power.svg',
        title: 'قدرت خرید شما شامل مبالغ حاصل از شارژ کیف پول،  اعتبار کارگزاری و فروش صندوق های ETF و سهام است.',
      },
    });
  }

  showWalletBalanceInfo() {
    this.bottomSheet.openBottomSheet(WalletBalanceInfoComponent, {
      data: {
        image: 'wealth-assets/svg/wallet-info.svg',
        title:
          'این موجودی ممکن است به دلیل در انتظار بودن مقداری از موجودی برای برداشت یا خرید، با قدرت خرید شما متفاوت باشد. می‌توانید این اطلاعات را در قسمت مبالغ در انتظار در سبد دارایی خود مشاهده کنید.',
      },
    });
  }

  cashout(all?: 'all') {
    this.isLoading.set(true);
    this.fundDataService
      .walletCashout({
        amount: all ? this.balance().balance : this.amount(),
      })
      .subscribe(
        (res) => {
          this.isLoading.set(false);

          this.navigationService.navigateWithQueryParams([RESULT_ROUTE], {
            queryParams: {
              status: res.success ? 'Succeed' : 'Failed',
              action: 'cashout',
              receiptNumber: res.result,
            },
          });
        },
        () => {
          this.isLoading.set(false);
          this.navigationService.navigateWithQueryParams([RESULT_ROUTE], {
            queryParams: {
              status: 'Failed',
              action: 'cashout',
            },
          });
        },
      );
  }
}
